export const calculateSearchResultRanking = (
  positionInPage,
  currentPage = 1,
  resultsPerPage = 20,
) => (currentPage - 1) * resultsPerPage + positionInPage;
